import * as React from "react";
import { Container, makeStyles } from "@material-ui/core";
import BackgroundPoints from "./assets/backgroundPoints.svg";

export const FunnelContainer = ({ children }) => {
  const classes = useStyle();
  return (
    <Container className={classes.inner} disableGutters>
      <div className={classes.container}>
        <BackgroundPoints className={classes.shape} />
        {children}
      </div>
    </Container>
  );
};

const useStyle = makeStyles((theme) => ({
  shape: {
    position: "absolute",
    left: 0,
    width: "calc(50vw - 480px)",
    top: 0,
    zIndex: -1,
  },
  container: {
    [theme.breakpoints.down("sm")]: {
      paddingBottom: 75,
    },
    inner: {
      maxWidth: 1120,
    },
  },
}));
